import React from 'react';

import IconGrid from '@pkg/assets/icons/grid.svg?react';
import IconList from '@pkg/assets/icons/list.svg?react';
import { FieldToggle, type FieldToggleProps } from '@pkg/components/forms';
import { useMediaQuery } from '@pkg/providers';

export interface ToggleGridProps {
    selected?: boolean;
    setSelected: (selected: boolean) => void;
}

export function ToggleGrid({ selected = false, setSelected }: ToggleGridProps) {
    const { tablet } = useMediaQuery();

    const handleSelected: FieldToggleProps['onToggle'] = (newSelection) => {
        setSelected(newSelection === 'list');
    };

    return (
        <FieldToggle
            options={[
                { id: 'grid', icon: IconGrid },
                { id: 'list', icon: IconList },
            ]}
            selected={selected ? 'list' : 'grid'}
            backdropBlur={!tablet}
            onToggle={handleSelected}
        />
    );
}
